import React, { useContext } from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { DialogHeader } from "../../../auth/components/DialogHeader";
import DangerBaseButton from "../../../main/components/DangerBaseButton";
import BaseButton from "../../../main/components/BaseButton";
import { MainContext } from "../../../main/context/MainContextProvider";
import { SinglePDFDropzone } from "../../../main/components/SinglePDFDropzone";

type AddFileModalProps = {
  open: boolean;
  title: string;
  label?: string;
  onConfirm: () => void;
  onCancel: () => void;
  onClose: () => void;
  file: File | null;
  loadingSaveFile: boolean;
  setFile: (file: File | null) => void;
};

const AddFileModal: React.FC<AddFileModalProps> = ({
  open,
  title,
  label,
  file,
  setFile,
  onConfirm,
  onCancel,
  loadingSaveFile,
  onClose,
}) => {
  const { theme } = useContext(MainContext);
  const primary = theme.muiTheme.palette.primary.main;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        {title}
      </DialogHeader>
      <DialogContent
        sx={{
          width: "500px",
          height: "140px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        dividers
      >
        <SinglePDFDropzone
          onUpload={(file) => setFile(file)}
          setUploadedFile={setFile}
          uploadedFile={file}
          label={label}
          sx={{ maxWidth: "450px" }}
        />
      </DialogContent>
      <DialogActions>
        <DangerBaseButton onClick={onCancel} title="Cancelar" />
        <BaseButton
          disabled={!file}
          loading={loadingSaveFile}
          sx={{
            backGroundColor: primary,
            borderColor: primary,
            height: "34px",
            width: "95px",
            "& .MuiTypography-root": {
              color: primary,
            },
            "&:hover": {
              borderColor: primary,
              backgroundColor: primary,
              color: primary,
              "& .MuiTypography-root": {
                color: "#FFFFFF",
              },
            },
          }}
          onClick={onConfirm}
          title="Salvar"
        />
      </DialogActions>
    </Dialog>
  );
};

export default AddFileModal;
